/* import __COLOCATED_TEMPLATE__ from './test-as-selector.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { action } from '@ember/object';

export interface Args {
  user?: any;
  displayUser?: any;
  onToggleSearchMode: () => void;
  onSelectUser: (user: any) => void;
  onToggleAudienceSearchMode?: () => void;
  onSelectAudienceMode?: () => void;
  playgroundSettings?: any;
  selectedAudienceName?: string | null;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class TestAsSelector extends Component<Signature> {
  get isPreviewUserSelected() {
    // Default when no audiences and no specific user
    return !this.args.playgroundSettings?.selectedContentSegmentIds?.length && !this.args.user;
  }

  get isSpecificUserSelected() {
    // Specific user when no audiences but we have a user
    return (
      !this.args.playgroundSettings?.selectedContentSegmentIds?.length && Boolean(this.args.user)
    );
  }

  get isAudienceSelected() {
    // Audience when we have selected content segments
    return Boolean(this.args.playgroundSettings?.selectedContentSegmentIds?.length);
  }

  get selectedAudienceName() {
    return this.args.selectedAudienceName;
  }

  @action
  selectPreviewUser() {
    // Reset to default user mode
    this.args.onSelectUser(null);
  }

  @action
  selectPreviewUserAndClose(hideDropdownOverlay: () => void) {
    this.selectPreviewUser();
    hideDropdownOverlay();
  }

  @action
  selectUserOrLead() {
    this.args.onToggleSearchMode();
  }

  @action
  selectAudience() {
    if (this.args.onSelectAudienceMode) {
      this.args.onSelectAudienceMode();
    } else if (this.args.onToggleAudienceSearchMode) {
      this.args.onToggleAudienceSearchMode();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Settings::TestAsSelector': typeof TestAsSelector;
    'ai-agent/playground/settings/test-as-selector': typeof TestAsSelector;
  }
}
